import { Flex, Text, Button } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    Input
} from "@chakra-ui/react";
import API from "../../api";

import withNavElements from "../../components/withNavElements";
import { getProductsAll } from "../../actions/productActions";
import AdminProductsTable from "./AdminProductsTable";
import { toast } from "react-hot-toast";

const TEXT_TIME_TYPING = 500;
let typingTimer = null;

const DashboardProductsPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const productsState = useSelector((state) => state.productsScreen);

    useEffect(() => {
        dispatch(getProductsAll({ page, limit }));
    }, [dispatch, page, limit]);

    const onChangeText = (e) => {
        const searchTerm = e.target.value;
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
            dispatch(getProductsAll({
                page: 1,
                limit: 10,
                searchTerm
            }));
        }, TEXT_TIME_TYPING);
    }

    const toggleProductActive = async (id, setLoading) => {
        setLoading(true);
        try{
            const { data } = await API.put(`/products/toggle?id=${id}`);
            if(data.ok){
                toast.success("Producto actualizado con éxito.");
                dispatch(getProductsAll({ page, limit }));
            }
            setLoading(false);
        }catch(err){
            setLoading(false);
            console.log(err);
            toast.error("Algo salió mal, inténtalo más tarde.");
        }
    }

    return (
        <>
            <Helmet>
                <title>Dashboard - Products</title>
            </Helmet>
            <Flex
                flex={1}
                minH="300px"
                h="100%"
                mt="70px"
                py="40px"
                px={{ base: 0, md: "20px" }}
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
            >
                <Flex 
                    w='100%'
                    justifyContent='center'
                    alignItems='center'
                    pos='relative'
                >
                    <Button
                        variant="ghost"
                        pos='absolute'
                        left='0'
                        onClick={() => history.goBack()}
                    >
                        <IoMdArrowBack size='25px' />
                    </Button>
                    <Text fontSize="1.5em" fontWeight="400" >
                        Gestión de Productos
                    </Text>
                </Flex>
                <Flex
                    mt="40px"
                    w="100%"
                    pt="50px"
                    pb='80px'
                    px={{ base: "40px", md: "40px" }}
                    flex={1}
                    minH="100%"
                    bg="gray.100"
                    borderRadius="10px"
                    justifyContent="center"
                    alignItems="center"
                    flexDir={"column"}
                >
                    <Input
                        alignSelf='flex-end'
                        w='200px'
                        type='text'
                        placeholder="Buscar producto..."
                        bg={productsState.loading ? 'gray.200' : 'white'}
                        mb='20px'
                        size='sm'
                        onChange={onChangeText}
                        borderRadius='8px'
                    />
                        <AdminProductsTable
                            products={productsState.allProducts.products?.docs || []}
                            loading={productsState.loading}
                            error={productsState.error}
                            currentPage={productsState.allStores?.currentPage || 0}
                            totalPages={productsState.allStores?.totalPages || 1}
                            page={page}
                            setPage={setPage}
                            limit={limit}
                            setLimit={setLimit}
                            toggleProductActive={toggleProductActive}
                        />
                </Flex>
            </Flex>
        </>
    );
}

export default withNavElements(DashboardProductsPage)